import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControlLabel,
  Switch,
  Stack,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import { useDispatch, useSelector } from "react-redux";
import CompanyVeiwController from "../../redux/actions/companyApiActions";
import { FadeLoader } from "react-spinners";

function AddAnnouncement({
  show,
  handleClose,
  initialData = null,
  currentUser,
  refreshList,
}) {
  const dispatch = useDispatch();
  const { AddAnnouncement, updateAnnouncement } = CompanyVeiwController();
  const { isLoding } = useSelector((state) => state.company);
  const isEdit = Boolean(initialData?.id);

  const [initialValues, setInitialValues] = useState({
    title: "",
    message: "",
    active: true,
  });

  useEffect(() => {
    if (show && initialData) {
      setInitialValues({
        title: initialData.title || "",
        message: initialData.message || "",
        active: initialData.active ?? true,
      });
    } else if (show && !initialData) {
      setInitialValues({
        title: "",
        message: "",
        active: true,
      });
    }
  }, [show, initialData]);

  const handleSubmit = (values, { resetForm }) => {
    const payload = { ...values };
    if (!isEdit) {
      payload.created_by = currentUser?.id;
    }

    const action = isEdit
      ? updateAnnouncement(initialData.id, payload)
      : AddAnnouncement(payload);

    dispatch(action)
      .then(() => {
        resetForm();
        handleClose();
        refreshList();
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
      });
  };

  return (
    <Dialog open={show} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {isEdit ? " Edit Announcement" : " Create Announcement"}
      </DialogTitle>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values, handleChange }) => (
          <Form>
            <DialogContent dividers>
              <Stack spacing={3}>
                <TextField
                  label="Title"
                  name="title"
                  value={values.title}
                  onChange={handleChange}
                  required
                  fullWidth
                />
                <TextField
                  label="Message"
                  name="message"
                  value={values.message}
                  onChange={handleChange}
                  multiline
                  minRows={3}
                  required
                  fullWidth
                />
                <FormControlLabel
                  control={
                    <Switch
                      name="active"
                      checked={values.active}
                      onChange={handleChange}
                      color="primary"
                    />
                  }
                  label="Active"
                />
              </Stack>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} variant="outlined" >
                Cancel
              </Button>
              <Button type="submit" variant="contained" color="primary">
                {isEdit ? "Update" : "Create"}
              </Button>
               {isLoding && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    height: "100vh",
                    width: "100vw",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "rgba(255, 255, 255, 0.6)",
                    zIndex: 9999,
                  }}
                >
                  <div
                    style={{
                      background:
                        "linear-gradient(45deg,rgb(65, 63, 63),rgb(238, 231, 238))",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    <FadeLoader loading={true} size={150} aria-label="Loading Spinner" />
                  </div>
                </div>
              )}
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}

export default AddAnnouncement;
